export default "__VITE_ASSET__DOb0$FL5__"